import isNil from "lodash.isnil";
import { twoZeroPad } from "./numbers";

export const isDate = (value) => {
    if (isNil(value) || value === "") {
        return false;
    }
    return value.split("/").length === 3;
};

export const isTime = (value) => {
    if (isNil(value) || value === "") {
        return false;
    }
    const dtSplit = value.split(":");
    return dtSplit.length === 2 || dtSplit.length === 3;
};

export const isFullTime = (value) => {
    if (isNil(value) || value === "") {
        return false;
    }
    return value.split(":").length === 3;
};

export const isDatetime = (value) => {
    if (isNil(value) || value === "") {
        return false;
    }
    const comps = value.split(" ");
    if (comps.length !== 2) {
        return false;
    }
    return isDate(comps[0]) && isTime(comps[1]);
};

export const isFullDatetime = (value) => {
    if (isNil(value) || value === "") {
        return false;
    }
    const comps = value.split(" ");
    if (comps.length !== 3) {
        return false;
    }
    return isDate(comps[0]) && isFullTime(comps[1]);
};

export const parseDate = (dateString, _format = undefined) => {
    let format = _format;

    if (format === undefined) {
        if (dateString.includes("/")) {
            format = "d/m/Y";
        } else if (dateString.includes("-")) {
            format = "Y-m-d";
        } else {
            return undefined;
        }
    }

    if (!isNil(dateString) && dateString !== "") {
        if (format === "d/m/Y") {
            const datesplit = dateString.split("/");
            return new Date(`${datesplit[1]} ${datesplit[0]} ${datesplit[2]}`);
        }
        if (format === "Y-m-d") {
            return new Date(dateString);
        }
    }
    return undefined;
};

export const parseDatetime = (value) => {
    if (isDatetime(value)) {
        const [ds, ts] = value.split(" ");
        const [day, month, year] = ds.split("/");
        const dtSplit = ts.split(":");
        if (dtSplit.length === 2) {
            return new Date(
                Number.parseInt(year),
                Number.parseInt(month) - 1,
                Number.parseInt(day),
                Number.parseInt(dtSplit[0]),
                Number.parseInt(dtSplit[1]),
                0,
            );
        }

        if (dtSplit.length === 3) {
            return new Date(
                Number.parseInt(year),
                Number.parseInt(month) - 1,
                Number.parseInt(day),
                Number.parseInt(dtSplit[0]),
                Number.parseInt(dtSplit[1]),
                Number.parseInt(dtSplit[2]),
            );
        }
    }
    if (value?.includes("T")) {
        return new Date(value);
    }
    return undefined;
};

export const dateToString = (date, format = "d/m/Y") => {
    if (date !== undefined) {
        if (format === "d/m/Y") {
            const day = twoZeroPad(date.getDate());
            const month = twoZeroPad(date.getMonth() + 1);
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        }
        if (format === "Y-m-d") {
            const day = twoZeroPad(date.getDate());
            const month = twoZeroPad(date.getMonth() + 1);
            const year = date.getFullYear();
            return `${year}-${month}-${day}`;
        }
    }
    return "";
};

export const nextDay = (datestr) => {
    const date = parseDate(datestr);
    if (!isNil(date)) {
        date.setDate(date.getDate() + 1);
        return dateToString(date);
    }
    return "";
};

export const previousDay = (datestr) => {
    const date = parseDate(datestr);
    if (!isNil(date)) {
        date.setDate(date.getDate() - 1);
        return dateToString(date);
    }
    return "";
};

export const today = () => dateToString(new Date());

export const tomorrow = () => nextDay(today());

export const datePlusDays = (datestr, days) => {
    const date = parseDate(datestr);
    if (!isNil(date)) {
        date.setDate(date.getDate() + days);
        return dateToString(date);
    }
    return "";
};

export const daysDelta = (datestr, delta) => {
    const date = parseDate(datestr);
    if (!isNil(date)) {
        date.setDate(date.getDate() + delta);
        return dateToString(date);
    }
    return 0;
};

export const datesDifferenceInDays = (first_date, last_date) => {
    const lastDate = parseDate(last_date);
    const firstDate = parseDate(first_date);
    return Math.round((lastDate - firstDate) / 86400000);
};
